import {
  FEEDBACK_SEND,
  FEEDBACK_SUCCESS,
  FEEDBACK_FAILURE,
  FEEDBACK_REFRESH,

  GET_SUBJECTS,
  GET_SUBJECTS_SUCCESS,
  GET_SUBJECTS_FAIL,

  CLEAR_INPUT_ERROR,
} from '../actions/feedback';

const initialState = {
  isSending: false,
  isFeedbackSended: false,
  isFeedbackError: false,
  feedbackErrors: {},
  feedbackErrorMessage: null,

  subjects : [],
  isSubjectsLoaded: false,
};

export default function feedback(state = initialState, action = {}) {
  switch (action.type) {
    case FEEDBACK_SEND:
      return {
        ...state,
        isSending: true,
        isFeedbackSended: false,
        isFeedbackError: false,
        feedbackErrors: {},
        feedbackErrorMessage: null,
      };

    case FEEDBACK_SUCCESS:
      return {
        ...state,
        isSending: false,
        isFeedbackSended: !action.response.errors,
        isFeedbackError: !!action.response.errors,
        feedbackErrors: action.response.errors,
        feedbackErrorMessage: null,
      };

    case FEEDBACK_FAILURE:
      return {
        ...state,
        isSending: false,
        isFeedbackSended: false,
        isFeedbackError: true,
        feedbackErrors: action.response.data.form_errors ?? {},
        feedbackErrorMessage: action.response.data.errors
      };

    case CLEAR_INPUT_ERROR:
      return {
        ...state,
        feedbackErrors: {
          ...state.feedbackErrors,
          [action.fieldName]: false
        }
      }

    case FEEDBACK_REFRESH:
      return {
        ...state,
        isSending: false,
        isFeedbackSended: false
      }

    case GET_SUBJECTS:
      return {
        ...state,
        isSubjectsLoaded: false,
        subjects: [],
      }

    case GET_SUBJECTS_SUCCESS:
      return {
        ...state,
        isSubjectsLoaded: true,
        subjects: action.response.feedbackSubject.map(item => ({
          ...item,
          id: +item.id,
          title: item.name
        }))
      }

    case GET_SUBJECTS_FAIL:
      return {
        ...state,
        isSubjectsLoaded: false,
        subjects: []
      }

    default:
      return state;
  }
}
